import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'kiene-key-value-list',
    templateUrl: './key-value-list.component.html',
    styleUrls: ['./key-value-list.component.scss'],
})
export class KeyValueListComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
